import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeHtml extends TraitRegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
}
